import { render, staticRenderFns } from "./RubricReviewModal.vue?vue&type=template&id=2b744876"
import script from "./RubricReviewModal.vue?vue&type=script&lang=js"
export * from "./RubricReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports